module.exports = __webpack_public_path__ + "img/制御工学4_8.013e7f8c.png";